export default __webpack_public_path__ + "static/media/breadCrumb-path.daf05e31.svg";